import {
  ISSUE_PERMIT,
  ISSUE_PERMIT_SUCCESS,
  ISSUE_PERMIT_ERROR,
  GET_PERMITS_BY_STUDENT,
  GET_PERMITS_BY_STUDENT_SUCCESS,
  GET_PERMITS_BY_STUDENT_ERROR,
} from './types';

const initialState = {
  permits: [],
  isLoading: false,
  isSubmitting: false,
  error: null,
  successMessage: null,
};

const assignPermitReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Issue permit
    case ISSUE_PERMIT:
      return {
        ...state,
        isSubmitting: true,
        error: null,
        successMessage: null,
      };
    case ISSUE_PERMIT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        successMessage: 'Permit issued successfully',
        permits: [payload, ...state.permits],
      };
    case ISSUE_PERMIT_ERROR:
      return {
        ...state,
        isSubmitting: false,
        error: 'Failed to issue permit',
      };

    // Get permits by student
    case GET_PERMITS_BY_STUDENT:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_PERMITS_BY_STUDENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        permits: payload,
      };
    case GET_PERMITS_BY_STUDENT_ERROR:
      return {
        ...state,
        isLoading: false,
        error: 'Failed to fetch permits',
      };

    default:
      return state;
  }
};

export default assignPermitReducer;
